import { graphql, useStaticQuery } from 'gatsby';
import omit from 'ramda/es/omit';

import { ConstConfigs, ConstConfigsQueryQuery } from 'types/codegen';

type ConstConfigsHookResult = Omit<ConstConfigs, 'id' | 'parent' | 'internal' | 'children'>;

export const useConstConfigs = (): ConstConfigsHookResult => {
  const { constConfigs } = useStaticQuery<ConstConfigsQueryQuery>(graphql`
    query ConstConfigsQuery {
      constConfigs {
        ENABLE_WIDGETS
        SHOW_CLIENT_ONLY_ROUTES
        SHOW_NOT_IMPLEMENTED_LINKS
        DISABLE_ICON_EDITING
        ENABLE_PARTNERS_SHOWCASE
        HIDE_COLLECTIONS
      }
    }
  `);

  return omit(['id'], constConfigs) || {};
};
